import React, { useState } from "react";
import { toast } from "sonner";
import client, { formatApiError } from "@/lib/api";

// Shown when a wallet is already linked to another account. Ownership never moves automatically.
export function RecoveryForm({ onClose }) {
  const [f, setF] = useState({ address: "", details: "", contact_email: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await client.post("/account/recovery-request", f); setSent(true); }
    catch (ex) { toast.error(formatApiError(ex.response?.data?.detail)); }
  };
  const input = "w-full rounded-xl bg-[#0d0d0d] border border-white/10 px-4 py-2.5 text-sm focus:outline-none focus:border-[#ccff00]/50";
  return (
    <div data-testid="wallet-conflict" className="rounded-xl border border-amber-400/30 bg-amber-400/5 p-5">
      <p className="text-sm font-semibold text-amber-300">This wallet is already linked to another OnchainLyfe account.</p>
      <p className="text-sm text-zinc-400 mt-1">For your safety we never move a wallet between accounts automatically. Sign in with that wallet to use its account, or ask our team to review ownership.</p>
      {sent ? (
        <p data-testid="recovery-sent" className="text-sm text-[#ccff00] mt-3">Request received. We'll verify ownership of both accounts before changing anything.</p>
      ) : (
        <form onSubmit={submit} className="grid gap-3 mt-4">
          <input data-testid="recovery-address" required className={input} placeholder="Wallet address (0x…)" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} />
          <input data-testid="recovery-email" className={input} placeholder="Contact email (optional)" value={f.contact_email} onChange={(e) => setF({ ...f, contact_email: e.target.value })} />
          <textarea data-testid="recovery-details" className={input} placeholder="What happened?" maxLength={1000} value={f.details} onChange={(e) => setF({ ...f, details: e.target.value })} />
          <div className="flex gap-3">
            <button data-testid="recovery-submit" className="px-5 py-2 rounded-full bg-amber-300 text-black text-sm font-semibold">Request review</button>
            <button type="button" onClick={onClose} className="px-5 py-2 rounded-full border border-white/10 text-sm text-zinc-300">Dismiss</button>
          </div>
        </form>
      )}
    </div>
  );
}
